

export const testimonioData = {
    title: "Lo que dicen nuestra gente",
    items: [
        {
            comentario: "<p><span>“<span>Desde que uso toke cobro más rápido y sin lío. Ya no tengo que estar cambiando dinero ni esperando transferencias.“</p>",
            autor: "Luis R."
        },
        {
            comentario: "<p>“Antes perdía ventas porque la gente no tenía efectivo. Con toke ahora solo escanean mi QR y paga de una vez.” </p>",
            autor: "Luis R."
        },
        {
            comentario: "<p>“La seguridad y rapidez de las transacciones son excelentes. ¡Por fin una app de pagos en la que confío plenamente! </p>",
            autor: "Ana Pérez"
        },
        {
            comentario: "<p>“toke me ha facilitado el día a día del negocio. Los pagos llegan al instante y puedo llevar mejor control de mis ventas.”</p>",
            autor: "Carlos M."
        },
        {
            comentario: "<p>“Me encanta que no necesito efectivo. Pago todo desde el celular y es súper rápido, literal en segundos.”</p>",
            autor: "María G."
        },
        {
            comentario: "<p>“Implementar toke en mi colmado fue de las mejores decisiones. Más clientes prefieren pagar digital y eso aumentó mis ventas.”</p>",
            autor: "José L."
        },

    ]
};
